import React from 'react';

import BreadcrumbNavigation from '../../components/root/Container/Layout/BreadcrumbNavigation/BreadcrumbNavigation';
import MenuOptions from '../../components/root/Container/Layout/MenuOptions/MenuOptions';

import Footer from './Footer/Footer';

import './Layout.scss';

export default function Layout({ children }) {
  return (
    <div className="page-inner-container">
      <div className="page-content">
        <MenuOptions />
        <BreadcrumbNavigation />
        {children}
        <Footer />
      </div>
    </div>
  );
}
